import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { DocFeedbackStatusDB } from '../../../../../../api/types/docs/doc-feedback-status';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';
import { UserType } from '../../../../../../api/types/user/user-type';
import globalUserPage from '../../../../../../stores/global-user-page';
import { DocDetails } from '../../../../../../api/types/docs/doc-details';

export const updateDocFeedbackStatusOperations = async (
  userId: number,
  user: UserSummaryType,
  dockId: number,
  feedbackId: number,
  status: DocFeedbackStatusDB,
  setDocs: (docs: DocDetails[]) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    // TODO api
    setLoading(true);
    const res = await appApi.updateDocFeedback(
      userId,
      dockId,
      feedbackId,
      status,
    );

    let docs: DocDetails[] = [];
    if (user.role === UserType.STUDENT) {
      docs = globalUserPage?.studentDetails?.docs ?? [];
    } else if (user.role === UserType.LECTURER) {
      docs = globalUserPage?.lecturerDetails?.docs ?? [];
    }

    // Create a new array with updated feedback status
    const updatedDocs = docs.map((doc) => ({
      ...doc,
      feedbacks: doc.feedbacks.map((feedback) =>
        feedback.id === feedbackId ? { ...feedback, status } : feedback,
      ),
    }));

    // Update the state with the new array
    setDocs(updatedDocs);
    setLoading(false);

    console.log(`${JSON.stringify(globalUserPage?.studentDetails?.docs)}`);

    // TODO update local state
    toast.success('הוספת התגובה התבצעה בהצלחה');
  } catch (e) {
    setLoading(false);
    toast.error(`הוספת התגובה נכשלה, נסה שוב בעוד מספר רגעים...`);
    console.error(
      `updateDocFeedbackStatusOperations is failed with the error: ${e}`,
    );
  }
};
